(() => {
  if (window.bitigProductZoomLoaded) return;
  window.bitigProductZoomLoaded = true;
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const pane = document.createElement('div');
  pane.className = 'bitig-product-zoom';
  pane.setAttribute('aria-hidden', 'true');
  pane.hidden = true;
  document.body.append(pane);
  let active = null;
  let dismissed = null;
  let position = { x: .5, y: .5 };
  const hide = () => { pane.hidden = true; active = null; };
  const show = (frame, x = .5, y = .5) => {
    if (!desktop.matches || dismissed === frame) return;
    const product = frame.closest('product-info');
    const center = product?.querySelector('.bitig-product-center');
    const img = frame.querySelector('.product__media img');
    if (!center || !img?.complete || !img.naturalWidth) return;
    const bounds = frame.getBoundingClientRect();
    const column = center.getBoundingClientRect();
    const width = Math.min(column.width, window.innerWidth - column.left - 16);
    const top = Math.max(12, bounds.top);
    const height = Math.min(620, Math.max(420, bounds.height * 1.5), window.innerHeight - top - 16);
    if (width < 260 || height < 220) return hide();
    const ratio = img.naturalWidth / img.naturalHeight;
    const zoomWidth = Math.max(bounds.width * 2.6, width * 1.5, height * ratio * 1.5);
    active = frame;
    position = { x: Math.max(0, Math.min(1, x)), y: Math.max(0, Math.min(1, y)) };
    Object.assign(pane.style, {
      left: `${column.left}px`, top: `${top}px`, width: `${width}px`, height: `${height}px`,
      backgroundImage: `url(${JSON.stringify(img.src)}), url(${JSON.stringify(img.currentSrc || img.src)})`,
      backgroundSize: `${zoomWidth}px ${zoomWidth / ratio}px`,
      backgroundPosition: `${position.x * 100}% ${position.y * 100}%`
    });
    pane.hidden = false;
  };
  const setup = () => {
    document.querySelectorAll('product-info .product__media-wrapper .media-type-image').forEach(frame => {
      if (frame.dataset.bitigZoomReady) return;
      frame.dataset.bitigZoomReady = 'true';
      frame.addEventListener('pointermove', event => {
        if (event.pointerType === 'touch') return;
        const rect = frame.getBoundingClientRect();
        show(frame, (event.clientX - rect.left) / rect.width, (event.clientY - rect.top) / rect.height);
      });
      frame.addEventListener('pointerleave', () => { dismissed = null; hide(); });
      frame.addEventListener('click', () => { dismissed = frame; hide(); });
      frame.addEventListener('focusout', () => { dismissed = null; hide(); });
      // The existing button still opens Dawn's accessible full-image dialog.
      frame.addEventListener('keydown', event => {
        const directions = { ArrowLeft: [-.1, 0], ArrowRight: [.1, 0], ArrowUp: [0, -.1], ArrowDown: [0, .1] };
        if (!directions[event.key] || !desktop.matches) return;
        event.preventDefault();
        dismissed = null;
        const [dx, dy] = directions[event.key];
        show(frame, (active === frame ? position.x : .5) + dx, (active === frame ? position.y : .5) + dy);
      });
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') { dismissed = active; hide(); }
  });
  window.addEventListener('scroll', hide, { passive: true, capture: true });
  window.addEventListener('resize', hide, { passive: true });
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', hide);
  new MutationObserver(setup).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  setup();
})();
